import React, { useState } from "react";

const API_ORIGIN = "https://api.buildbright.app";
const CONTRACTORS_API = `${API_ORIGIN}/api/contractor`;

export default function ContractorLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");

    try {
      const res = await fetch(`${CONTRACTORS_API}/signin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json().catch(() => ({}));
      const ok = data?.success === true || data?.ok === true;

      if (!res.ok || !ok) {
        setMsg(data?.detail || "Login failed. Check email/password.");
        setLoading(false);
        return;
      }

      // Store token in localStorage for cross-domain auth
      const sessionToken = data?.token || data?.access_token || data?.session_token;
      if (sessionToken) {
        localStorage.setItem("bb_contractor_token", sessionToken);
      }
      // Also store contractor info
      if (data?.contractor) {
        localStorage.setItem("bb_contractor", JSON.stringify(data.contractor));
      }

      window.location.href = "/#/contractors/portal";
    } catch (err) {
      setMsg("Network error. Try again.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-zinc-900 rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold text-white">Contractor Login</h1>
        <p className="text-zinc-400 mt-1">Sign in to view your leads.</p>

        {msg ? (
          <div className="mt-4 bg-red-900 border border-red-700 text-red-300 text-sm rounded p-3">
            {msg}
          </div>
        ) : null}

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-zinc-300 mb-1">Email</label>
            <input
              type="email"
              className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-3 py-2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-zinc-300 mb-1">Password</label>
            <input
              type="password"
              className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-3 py-2"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <div className="flex items-center justify-between">
            <a href="/#/contractor/forgot" className="text-sm text-orange-400 underline">
              Forgot password?
            </a>
            <a href="/#/contractors/signup" className="text-sm text-orange-400 underline">
              Create account
            </a>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white font-medium px-4 py-2 rounded-md"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
